var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui icon button",attrs:{"data-position":_vm.position,"data-tooltip":_vm.text,"data-inverted":""}},[_c('sui-icon',{attrs:{"name":"question circle outline"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }